<section
  class="chart-container mx-auto flex h-[200px] w-[500px] items-center justify-center"
>
  @if (loading) {
    <div class="loading-spinner mt-6">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  }
  <div class="flex h-[200px] w-[300px]">
    <canvas
      class="chart-canvas"
      baseChart
      [data]="pieChartData"
      [options]="pieChartOptions"
      [labels]="pieChartData.labels"
      [type]="pieChartType"
    ></canvas>
  </div>
  <ul class="flex min-w-[280px] flex-1 flex-col gap-[10px] pt-2">
    @for (item of legendItems; track item.label) {
      <li class="flex items-center gap-2 text-sm text-white">
        <span
          class="inline-block h-4 w-4 flex-shrink-0 rounded-[2px]"
          [style.background-color]="item.color"
        ></span>
        <span class="whitespace-nowrap leading-tight">{{ item.label }}</span>
      </li>
    }
  </ul>
</section>
